import { variant, space } from 'styled-system';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Text from '../Text';

export const Badge = styled(Text)`
  font-size: 10px;
  font-weight: 500;
  padding: 2px 5px;
  color: ${themeGet('colors.black.40')};
  display: inline-flex;
  margin: 0 1px;
  justify-content: center;
  align-items: center;
  text-transform: capitalize;
  vertical-align: middle;
  ${variant({
    variants: {
      black: {
        backgroundColor: '#000',
        color: '#fff',
        border: '1px #000 solid',
        borderRadius: '50rem',
      },
      grey: {
        backgroundColor: '#E8E8E8',
        color: '#25282B',
        borderRadius: '50rem',
        gap: '4px',
      },
      green: {
        backgroundColor: 'rgba(42, 199, 105, 1)',
        color: '#fff',
        border: '1px rgba(42, 199, 105, 1) solid',
        borderRadius: '50rem',
      },
      orange: {
        backgroundColor: 'rgba(232, 152, 6, 1)',
        color: '#000',
        border: '1px rgba(232, 152, 6, 1) solid',
        borderRadius: '50rem',
      },
      red: {
        backgroundColor: '#EC0404',
        color: '#fff',
        border: '1px rgba(232, 152, 6, 1) solid',
        borderRadius: '50rem',
      },
      teal: {
        backgroundColor: 'rgb(15 170 212)',
        color: '#fff',
        border: '1px rgb(15 170 212) solid',
        borderRadius: '50rem',
      },
      blue: {
        backgroundColor: '#3b82f6',
        color: '#fff',
        border: '1px #3b82f6 solid',
        borderRadius: '50rem',
      },
      lightBlue: {
        backgroundColor: 'primary.20',
        color: '#000',
        border: `1px solid`,
        borderColor: 'primary.20',
        borderRadius: '50rem',
      },
      rounded: {
        display: 'inline-block',
        fontSize: '12px',
        fontWeight: '500',
        lineHeight: '1',
        textAlign: 'center',
        verticalAlign: 'baseline',
        padding: '5px 10px',
        whiteSpace: 'nowrap',
        borderRadius: '50rem',
        textTransform: 'none',
      },
    },
  })}
  ${space};
`;
